import { Box } from "@/Components/v2/atoms/Box";
import { Typography } from "@/Components/v2/atoms/Typography";

type ColumnHeaderProps = {
  header: string;
  subHeader?: string;
};

const ColumnHeader = ({ header, subHeader }: ColumnHeaderProps) => (
  <Box sx={{ display: "flex", flexDirection: "column" }}>
    <Typography fontSize={12} fontWeight={600}>
      {header}
    </Typography>
    {subHeader && <Typography fontSize={12}>{subHeader}</Typography>}
  </Box>
);

export default ColumnHeader;
